export const getStrokeDasharray = (percentage, radius = 50) => {
  const circumference = 2 * Math.PI * radius
  const angle = (percentage / 100) * circumference
  const strokeDasharray = (circumference * angle) / 360
  return `${strokeDasharray} ${circumference - strokeDasharray}`
}

export const getStrokeDashoffset = (offset = 0.25, radius = 50) => {
  // rotating from the start (on the right) to part of circle}
  return offset * 2 * Math.PI * radius
}
